import { useMemo } from 'react';

import { useFlowContext } from './useFlowContext';
import { createFlowUrl, type UrlType } from '../utils/createFlowUrl';

export const useFlowUrl = ({
  type = 'absoluteUrl',
  route,
}: { type?: UrlType; route?: string } = {}) => {
  const context = useFlowContext();

  return useMemo(
    () => createFlowUrl({ context, route, type }),
    [context, route, type],
  );
};
